import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {doc, getDoc} from 'firebase/firestore';
import {useData} from '../../context/DataContext';
import { useLang} from '../../context/LanguageContext';
import { FaArrowLeft } from 'react-icons/fa';
import BgImage from '../../images/games_bg.png';
import {useAuth} from "../../context/AuthContext";
import {db} from '../../utils/firebase';
import {DEFAULT_HIGH_ODDS_AI_ENABLED} from '../../utils/highOddsAI';
import Footer from "../../components/Footer";
import Loading from "../../components/Loading";
import AITicketsSection from "../../components/AITicketsSection";

const HighOddsAIPage = () => {
  const navigate = useNavigate();
  const { highOddsAIGames } = useData();
  const { t } = useLang()
  const { hasPaid } = useAuth();
  const [dayFilter, setDayFilter] = useState('all');
  const [enabled, setEnabled] = useState(DEFAULT_HIGH_ODDS_AI_ENABLED);
  const [settingsLoaded, setSettingsLoaded] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const snap = await getDoc(doc(db, 'appSettings', 'highOddsAI'));
        if (snap.exists() && typeof snap.data().enabled === 'boolean') {
          setEnabled(snap.data().enabled);
        }
      } catch (err) {
        // pastram valoarea default daca nu putem citi
      }
      setSettingsLoaded(true);
    };
    loadSettings();
  }, []);

  const getConfidenceStyle = (confidence) => {
    if (confidence === 'HIGH') return 'bg-green-500';
    if (confidence === 'MEDIUM') return 'bg-yellow-500';
    return 'bg-red-500';
  };

  const backButton = (
    <button
      onClick={() => navigate(-1)}
      className="absolute top-5 left-5 px-4 py-2 bg-[#2ecc71] rounded flex items-center space-x-2"
    >
      <FaArrowLeft />
      <span className="text-white">{t('btn.back')}</span>
    </button>
  );

  if (!settingsLoaded) {
    return (
      <div className="bg-[#34495e] min-h-screen p-5 relative">
        {backButton}
        <div className="pt-24">
          <Loading/>
        </div>
      </div>
    );
  }

  if (!enabled) {
    return (
      <div className="bg-[#34495e] min-h-screen p-5 relative">
        {backButton}
        <p className="text-center text-yellow-300 text-sm pt-24">
          {t('txt.highOddsAIDisabled')}
        </p>
        <Footer/>
      </div>
    );
  }

  if (!highOddsAIGames) {
    return (
      <div className="bg-gray-100 min-h-screen flex flex-col items-center justify-center relative">
        {backButton}
        <div>Loading...</div>
      </div>
    );
  }

  const uniqueDates = Array.from(new Set(highOddsAIGames.map((g) => g.date))).sort();

  const filteredGames = highOddsAIGames.filter((game) => {
    if (dayFilter === 'all') return true;
    return game.date === dayFilter;
  });

  return (
    <div className="bg-[#34495e] min-h-screen p-5 relative">
      {backButton}

      <h1 className="text-white text-xl font-bold mb-4 text-center mt-16">
        {t('txt.highOddsAITitle')}
      </h1>

      <AITicketsSection />

      <div className="max-w-xs mx-auto mb-4">
        <label className="block mb-1 font-semibold text-sm text-white">
         {t('txt.filterDays')}
        </label>
        <select
          className="w-full border border-gray-300 rounded px-2 py-1"
          value={dayFilter}
          onChange={(e) => setDayFilter(e.target.value)}
        >
          <option value="all">{t('txt.selectDays')}</option>
          {uniqueDates.map((date) => (
            <option key={date} value={date}>
              {date}
            </option>
          ))}
        </select>
      </div>

      <div className="space-y-4">
        {filteredGames.map((game) => {
          const confidence = game.pick?.confidence;

          return (
            <div
              key={game.match_id || game.id}
              className="
                relative rounded shadow
                p-4 text-white bg-cover bg-center
                min-h-[140px]
                border-r-2
                border-[#27ae60]
              "
              style={{
                backgroundImage: `url(${BgImage})`,
              }}
            >
              <div className="w-full h-2 rounded mb-2 overflow-hidden">
                <div className={`${getConfidenceStyle(confidence)} h-full w-full`} />
              </div>

              <div className="flex items-center mb-2">
                <span className="font-bold text-sm">{game.country}</span>
                <span className="text-xs text-gray-300 ml-2">{game.league}</span>
              </div>

              <div className="text-sm font-semibold mb-1">
                {game.home_team} vs {game.away_team}
              </div>

              <div className="text-sm mb-2">
                <span className="mr-4">{game.date}</span>
                <span>{game.time}</span>
              </div>

              {hasPaid ? (
                <div className="text-sm">
                  <span>{game.pick?.label}</span>
                  {' - '}
                  <span className="text-lg font-bold text-green-300">{game.pick?.odds}</span>
                </div>
              ) : (
                <button
                  onClick={() => navigate('/account')}
                  className="px-3 py-1 bg-blue-500 text-white rounded text-sm"
                >
                    {t('btn.unlockPremium')}
                </button>
              )}
            </div>
          );
        })}

        {filteredGames.length === 0 && (
          <p className="text-center text-gray-500">
            No matches found for this day.
          </p>
        )}
      </div>
        <Footer />
    </div>
  );
};

export default HighOddsAIPage;
